module.exports = __webpack_public_path__ + "img/virtual-sports1.648976c0.png";